export enum PermissionConsts {
    // Pages

    Pages_Users = 'Pages.Users',
    Pages_Persons = 'Pages.Persons',
    Pages_Partners = 'Pages.Partners',
    Pages_CoWorkers = 'Pages.CoWorkers',

    // User

    User_Create = 'User.Create',
    User_Detail = 'User.Detail',
    User_Edit = 'User.Edit',
    User_Delete = 'User.Delete',
    User_Get = 'User.Get',
    User_RequestEmailConfirmation = 'User.RequestEmailConfirmation',
    User_GetAll = 'User.GetAll',
    User_ForceResetPassword = 'User.ForceResetPassword',
    User_Deactivate = 'User.Deactivate',
    User_UnlockLogin = 'User.UnlockLogin',

    // Files

    File_List = 'File.List',
    File_Detail = 'File.Detail',
    File_Create = 'File.Create',
    File_Delete = 'File.Delete',

    // Contact Person

    ContactPerson_Create = 'ContactPerson.Create',
    ContactPerson_Update = 'ContactPerson.Update',
    ContactPerson_Get = 'ContactPerson.Get',
    ContactPerson_GetAll = 'ContactPerson.GetAll',
    ContactPerson_Delete = 'ContactPerson.Delete',

    // Partner User

    PartnerUser_Create = 'ContactPerson.Create',
    PartnerUser_Get = 'ContactPerson.Get',
    PartnerUser_GetAll = 'ContactPerson.GetAll',
    PartnerUser_Delete = 'ContactPerson.Delete',

    // Residence Info

    ResidenceInfo_Create = 'ResidenceInfo.Create',
    ResidenceInfo_Update = 'ResidenceInfo.Update',
    ResidenceInfo_Get = 'ResidenceInfo.Get',
    ResidenceInfo_GetAll = 'ResidenceInfo.GetAll',
    ResidenceInfo_Delete = 'ResidenceInfo.Delete',

    // Personal Info

    PersonalInfo_Create = 'PersonalInfo.Create',
    PersonalInfo_Update = 'PersonalInfo.Update',
    PersonalInfo_Get = 'PersonalInfo.Get',
    PersonalInfo_GetAll = 'PersonalInfo.GetAll',
    PersonalInfo_Delete = 'PersonalInfo.Delete',

    // Selection

    Selection_Create = 'Selection.Create',
    Selection_Get = 'Selection.Get',
    Selection_GetAll = 'Selection.GetAll',
    Selection_Update = 'Selection.Update',
    Selection_Delete = 'Selection.Delete',
    Selection_EditPartner = 'Selection.EditPartner',
    Selection_AdvanceFilters = 'Selection.AdvancedFilters',
    Job_And_OtherDetails = 'Selection.JobAndOtherDetails',

    //Operative Units

    OperativeUnit_Create = 'OperativeUnit.Create',
    OperativeUnit_Get = 'OperativeUnit.Get',
    OperativeUnit_GetAll = 'OperativeUnit.GetAll',
    OperativeUnit_Update = 'OperativeUnit.Update',
    OperativeUnit_Delete = 'OperativeUnit.Delete',

    //Profile

    Admin_Profile = 'Admin_Profile',
    PiattaformaOrso_Profile = 'PiattaformaOrso_Profile',
    Person_Profile = 'Person_Profile',
    Partner_Profile = 'Partner_Profile',

    //Candidate

    Candidates_List = 'Candidates.List',

    //Matching

    User_SelectionMatching = 'User.SelectionMatching',

    // RequestApprenticeship
    RequestApprenticeship_Create = 'RequestApprenticeship.Create',
    RequestApprenticeship_Update = 'RequestApprenticeship.Update',
    RequestApprenticeship_Delete = 'RequestApprenticeship.Delete',
    RequestApprenticeship_Get = 'RequestApprenticeship.Get',
    RequestApprenticeship_GetAll = 'RequestApprenticeship.GetAll',

    // Apprenticeship
    Apprenticeship_Create = 'Apprenticeship.Create',
    Apprenticeship_Update = 'Apprenticeship.Update',
    Apprenticeship_Delete = 'Apprenticeship.Delete',
    Apprenticeship_Get = 'Apprenticeship.Get',
    Apprenticeship_GetAll = 'Apprenticeship.GetAll',

    // CompensationPaymentRequest
    CompensationPaymentRequest_Create = 'CompensationPaymentRequest.Create',
    CompensationPaymentRequest_Update = 'CompensationPaymentRequest.Update',
    CompensationPaymentRequest_Delete = 'CompensationPaymentRequest.Delete',
    CompensationPaymentRequest_Get = 'CompensationPaymentRequest.Get',
    CompensationPaymentRequest_GetAll = 'CompensationPaymentRequest.GetAll',
    CompensationPaymentRequest_Export = 'CompensationPaymentRequest.Export',

    //OrderCodes
    OrderCodes_List = 'OrderCode.List',
    OrderCodes_Create = 'OrderCode.Create',
    OrderCodes_Update = 'OrderCode.Update',
    OrderCodes_Delete = 'OrderCode.Delete',
    OrderCodes_Pages = 'OrderCode.Pages',

    // LaborConsultant
    LaborConsultant_List = 'LaborConsultant.List',
    LaborConsultant_Delete = 'LaborConsultant.Delete',
    LaborConsultant_Update = 'LaborConsultant.Update',
    LaborConsultant_Create = 'LaborConsultant.Create',
    LaborConsultant_ExportCompanies = 'LaborConsultant.ExportCompanies',
}
